'use client'

import { useContext } from 'react'

import { logWarning } from '@marketplace-web/shared/logging'

import { AbTestsContext } from '../context'

const useAbTest = (name: string) => {
  const abTest = useContext(AbTestsContext)[name]

  if (typeof abTest === 'undefined') {
    logWarning(`A/B test "${name}" is not defined. Please check your A/B test configuration.`)
  }

  return abTest
}

export default useAbTest
